$(document).ready(function () {
    if (currentUrl.includes('tracker')) {
        notDeliveredList();
    }
    if (currentUrl.includes('exception')) {
        exceptionList();
    }
    if (currentUrl.includes('delayed')) {
        delayedList();
    }
    if (currentUrl.includes('delivered')) {
        deliveredList();
    }
    if (currentUrl.includes('dismissed')) {
        dismissedList();
    }
    if (currentUrl.includes('void')) {
        voidList();
    }
    if (currentUrl.includes('shipped/today')) {
        shippedTodayList();
    }
});
window.notDeliveredList = notDeliveredList;
window.exceptionList = exceptionList;
window.delayedList = delayedList;
window.deliveredList = deliveredList;
window.dismissedList = dismissedList;
window.voidList = voidList;
window.shippedTodayList = shippedTodayList;
function notDeliveredList() {
    $("#select_all").click(function () {
        $(".not_delivered_checkbox").prop("checked", this.checked);
    });

    if (currentUrl.includes('tracker')) {
        if ($.fn.DataTable) {
            if ($.fn.DataTable.isDataTable('#tracking_list')) {
                $('#tracking_list').DataTable().clear().destroy();
            }
            
        $("#tracking_list").DataTable({
                "columnDefs": [
                {
                    "targets": 9, // Target the first column (index 0)
                    "createdCell": function (td, cellData, rowData, row, col) {
                        if (rowData.physical_confirmation == "True") { // Example condition: change color if cell data is less than 10
                           $(td).addClass('bg-success');
                        }
                    }
                }
            ],
            responsive: true,
            processing: true,
            serverSide: true,
            pagingType: "full_numbers",
            lengthMenu: [[50, 100, 200], [50, 100, 200]],
            pageLength: 50,
            fixedHeader: true,
            columns: [
                {
                    data: "id",
                    orderable: false,
                    searchable: false,
                    render: function (data, type, row) {
                        return `<input type='checkbox' class='not_delivered_checkbox' onchange='selectTabCheckbox("not_delivered")' value='${data}'/>`;
                    },
                    checkboxes: {
                        selectRow: true,
                    },
                },
                {
                    data: "Carrier",
                    name: "Carrier",
                    orderable: true,
                    searchable: true,
                },
                {
                    data: "order_no",
                    name: "order_no",
                    orderable: true,
                    searchable: true,
                },
                {
                    data: "tracking_number",
                    name: "tracking_number",
                    orderable: true,
                    searchable: true,
                },
                {
                    data: "shipped_date",
                    name: "shipped_date",
                    orderable: true,
                    searchable: true,
                },
                {
                    data: "expected_delivery_date",
                    name: "expected_delivery_date",
                    orderable: true,
                    searchable: true,
                },
                {
                    data: "status",
                    name: "status",
                    orderable: true,
                    searchable: true,
                },
                {
                    data: "status_update_date",
                    name: "status_update_date",
                    orderable: true,
                    searchable: true,
                },
                {
                    data: "last_update",
                    name: "last_update",
                    orderable: true,
                    searchable: true,
                },
                {
                    data: "physical_confirmation",
                    name: "physical_confirmation",
                    orderable: true,
                    searchable: true,
                },
                {
                    data: "actions",
                    name: "actions",
                    orderable: true,
                    searchable: true,
                },
            ],
            ajax: "/tracker",
            destroy: true,
        });
        }
    }
}

function exceptionList() {
    $("#exception_select_all").click(function () {
        $(".exception_checkbox").prop("checked", this.checked);
    });

    $("#exception_tracking_list1").DataTable({
        responsive: true,
        processing: true,
        serverSide: true,
        pagingType: "full_numbers",
        lengthMenu: [[50, 100, 200], [50, 100, 200]],
        pageLength: 50,
        fixedHeader: true,
        columns: [
            {
                data: "id",
                orderable: false,
                searchable: false,
                render: function (data, type, row) {
                    return `<input type='checkbox' class='exception_checkbox' onchange='selectTabCheckbox("exception")' value='${data}'/>`;
                },
                checkboxes: {
                    selectRow: true,
                },
            },
            {
                data: "Carrier",
                name: "Carrier",
                orderable: true,
                searchable: true,
            },
            {
                data: "order_no",
                name: "order_no",
                orderable: true,
                searchable: true,
            },
            {
                data: "tracking_number",
                name: "tracking_number",
                orderable: true,
                searchable: true,
            },
            {
                data: "shipped_date",
                name: "shipped_date",
                orderable: true,
                searchable: true,
            },
            {
                data: "expected_delivery_date",
                name: "expected_delivery_date",
                orderable: true,
                searchable: true,
            },
            {
                data: "status",
                name: "status",
                orderable: true,
                searchable: true,
            },
            {
                data: "status_update_date",
                name: "status_update_date",
                orderable: true,
                searchable: true,
            },
            {
                data: "last_update",
                name: "last_update",
                orderable: true,
                searchable: true,
            },
            {
                data: "physical_confirmation",
                name: "physical_confirmation",
                orderable: true,
                searchable: true,
            },
            {
                data: "actions",
                name: "actions",
                orderable: true,
                searchable: true,
            },
        ],
        ajax: "/exception/list",
        destroy: true,
    });
}

function delayedList() {
    $("#delayed_select_all").click(function () {
        $(".delayed_checkbox").prop("checked", this.checked);
    });

    $("#delayed_tracking_list").DataTable({
        responsive: true,
        processing: true,
        serverSide: true,
        pagingType: "full_numbers",
        lengthMenu: [[50, 100, 200], [50, 100, 200]],
        pageLength: 50,
        fixedHeader: true,
        columns: [
            {
                data: "id",
                orderable: false,
                searchable: false,
                render: function (data, type, row) {
                    return `<input type='checkbox' class='delayed_checkbox' onchange='selectTabCheckbox("delayed")' value='${data}'/>`;
                },
                checkboxes: {
                    selectRow: true,
                },
            },
            {
                data: "Carrier",
                name: "Carrier",
                orderable: true,
                searchable: true,
            },
            {
                data: "order_no",
                name: "order_no",
                orderable: true,
                searchable: true,
            },
            {
                data: "tracking_number",
                name: "tracking_number",
                orderable: true,
                searchable: true,
            },
            {
                data: "shipped_date",
                name: "shipped_date",
                orderable: true,
                searchable: true,
            },
            {
                data: "expected_delivery_date",
                name: "expected_delivery_date",
                orderable: true,
                searchable: true,
            },
            {
                data: "status",
                name: "status",
                orderable: true,
                searchable: true,
            },
            {
                data: "status_update_date",
                name: "status_update_date",
                orderable: true,
                searchable: true,
            },
            {
                data: "last_update",
                name: "last_update",
                orderable: true,
                searchable: true,
            },
                        {
                data: "physical_confirmation",
                name: "physical_confirmation",
                orderable: true,
                searchable: true,
            },
            {
                data: "actions",
                name: "actions",
                orderable: true,
                searchable: true,
            },
        ],
        ajax: "/delayed/list",
        destroy: true,
    });
}

function deliveredList() {
    $("#delivered_select_all").click(function () {
        $(".delivered_checkbox").prop("checked", this.checked);
    });

    $("#delivered_tracking_list").DataTable({
        responsive: true,
        processing: true,
        serverSide: true,
        pagingType: "full_numbers",
        lengthMenu: [[50, 100, 200], [50, 100, 200]],
        pageLength: 50,
        fixedHeader: true,
        columns: [
            {
                data: "id",
                orderable: false,
                searchable: false,
                render: function (data, type, row) {
                    return `<input type='checkbox' class='delivered_checkbox' onchange='selectTabCheckbox("delivered")' value='${data}'/>`;
                },
                checkboxes: {
                    selectRow: true,
                },
            },
            {
                data: "Carrier",
                name: "Carrier",
                orderable: true,
                searchable: true,
            },
            {
                data: "order_no",
                name: "order_no",
                orderable: true,
                searchable: true,
            },
            {
                data: "tracking_number",
                name: "tracking_number",
                orderable: true,
                searchable: true,
            },
            {
                data: "shipped_date",
                name: "shipped_date",
                orderable: true,
                searchable: true,
            },
            {
                data: "expected_delivery_date",
                name: "expected_delivery_date",
                orderable: true,
                searchable: true,
            },
            {
                data: "delivered_date",
                name: "delivered_date",
                orderable: true,
                searchable: true,
            },
            {
                data: "status",
                name: "status",
                orderable: true,
                searchable: true,
            },
            {
                data: "status_update_date",
                name: "status_update_date",
                orderable: true,
                searchable: true,
            },
            {
                data: "last_update",
                name: "last_update",
                orderable: true,
                searchable: true,
            },
                        {
                data: "physical_confirmation",
                name: "physical_confirmation",
                orderable: true,
                searchable: true,
            },
            {
                data: "actions",
                name: "actions",
                orderable: true,
                searchable: true,
            },
        ],
        ajax: "/delivered/list",
        destroy: true,
    });
}

function dismissedList() {
    $("#dismissed_select_all").click(function () {
        $(".dismissed_checkbox").prop("checked", this.checked);
    });

    $("#dismissed_tracking_list").DataTable({
        responsive: true,
        processing: true,
        serverSide: true,
        pagingType: "full_numbers",
        lengthMenu: [[50, 100, 200], [50, 100, 200]],
        pageLength: 50,
        fixedHeader: true,
        columns: [
            {
                data: "id",
                orderable: false,
                searchable: false,
                render: function (data, type, row) {
                    return `<input type='checkbox' class='dismissed_checkbox' onchange='selectTabCheckbox("dismissed")' value='${data}'/>`;
                },
                checkboxes: {
                    selectRow: true,
                },
            },
            {
                data: "Carrier",
                name: "Carrier",
                orderable: true,
                searchable: true,
            },
            {
                data: "order_no",
                name: "order_no",
                orderable: true,
                searchable: true,
            },
            {
                data: "tracking_number",
                name: "tracking_number",
                orderable: true,
                searchable: true,
            },
            {
                data: "shipped_date",
                name: "shipped_date",
                orderable: true,
                searchable: true,
            },
            {
                data: "expected_delivery_date",
                name: "expected_delivery_date",
                orderable: true,
                searchable: true,
            },
            {
                data: "delivered_date",
                name: "status_update_date",
                orderable: true,
                searchable: true,
            },
            {
                data: "status",
                name: "status",
                orderable: true,
                searchable: true,
            },
            {
                data: "status_update_date",
                name: "status_update_date",
                orderable: true,
                searchable: true,
            },
            {
                data: "last_update",
                name: "last_update",
                orderable: true,
                searchable: true,
            },
                        {
                data: "physical_confirmation",
                name: "physical_confirmation",
                orderable: true,
                searchable: true,
            },
            {
                data: "actions",
                name: "actions",
                orderable: true,
                searchable: true,
            },
        ],
        ajax: "/dismissed/list",
        destroy: true,
    });
}

function voidList() {
    $("#void_select_all").click(function () {
        $(".void_checkbox").prop("checked", this.checked);
    });

    $("#void_tracking_list").DataTable({
        responsive: true,
        processing: true,
        serverSide: true,
        pagingType: "full_numbers",
        lengthMenu: [[50, 100, 200], [50, 100, 200]],
        pageLength: 50,
        fixedHeader: true,
        columns: [
            {
                data: "id",
                orderable: false,
                searchable: false,
                render: function (data, type, row) {
                    return `<input type='checkbox' class='void_checkbox' onchange='selectTabCheckbox("void")' value='${data}'/>`;
                },
                checkboxes: {
                    selectRow: true,
                },
            },
            {
                data: "Carrier",
                name: "Carrier",
                orderable: true,
                searchable: true,
            },
            {
                data: "order_no",
                name: "order_no",
                orderable: true,
                searchable: true,
            },
            {
                data: "tracking_number",
                name: "tracking_number",
                orderable: true,
                searchable: true,
            },
            {
                data: "shipped_date",
                name: "shipped_date",
                orderable: true,
                searchable: true,
            },
            {
                data: "expected_delivery_date",
                name: "expected_delivery_date",
                orderable: true,
                searchable: true,
            },
            {
                data: "delivered_date",
                name: "status_update_date",
                orderable: true,
                searchable: true,
            },
            {
                data: "status",
                name: "status",
                orderable: true,
                searchable: true,
            },
            {
                data: "status_update_date",
                name: "status_update_date",
                orderable: true,
                searchable: true,
            },
            {
                data: "last_update",
                name: "last_update",
                orderable: true,
                searchable: true,
            },
                        {
                data: "physical_confirmation",
                name: "physical_confirmation",
                orderable: true,
                searchable: true,
            },
            {
                data: "actions",
                name: "actions",
                orderable: true,
                searchable: true,
            },
        ],
        ajax: "/void/list",
        destroy: true,
    });
}

function shippedTodayList() {
    $("#shippedToday_select_all").click(function () {
        $(".shippedToday_checkbox").prop("checked", this.checked);
    });

    $("#shippedToday_tracking_list").DataTable({
        responsive: true,
        processing: true,
        serverSide: true,
        pagingType: "full_numbers",
        lengthMenu: [[50, 100, 200], [50, 100, 200]],
        pageLength: 50,
        fixedHeader: true,
        columns: [
            {
                data: "id",
                orderable: false,
                searchable: false,
                render: function (data, type, row) {
                    return `<input type='checkbox' class='shippedToday_checkbox' onchange='selectTabCheckbox("shippedToday")' value='${data}'/>`;
                },
                checkboxes: {
                    selectRow: true,
                },
            },
            {
                data: "Carrier",
                name: "Carrier",
                orderable: true,
                searchable: true,
            },
            {
                data: "order_no",
                name: "order_no",
                orderable: true,
                searchable: true,
            },
            {
                data: "tracking_number",
                name: "tracking_number",
                orderable: true,
                searchable: true,
            },
            {
                data: "shipped_date",
                name: "shipped_date",
                orderable: true,
                searchable: true,
            },
            {
                data: "expected_delivery_date",
                name: "expected_delivery_date",
                orderable: true,
                searchable: true,
            },
            {
                data: "delivered_date",
                name: "status_update_date",
                orderable: true,
                searchable: true,
            },
            {
                data: "status",
                name: "status",
                orderable: true,
                searchable: true,
            },
            {
                data: "status_update_date",
                name: "status_update_date",
                orderable: true,
                searchable: true,
            },
            {
                data: "last_update",
                name: "last_update",
                orderable: true,
                searchable: true,
            },
                        {
                data: "physical_confirmation",
                name: "physical_confirmation",
                orderable: true,
                searchable: true,
            },
            {
                data: "actions",
                name: "actions",
                orderable: true,
                searchable: true,
            },
        ],
        ajax: "/shipped/today/list",
        destroy: true,
    });
}

function selectTabCheckbox(tabName) {
    const checkboxClass = `.${tabName}_checkbox`;
    const selectAllId = `#${tabName}_select_all`;

    const actualSelectAllId = tabName === "not_delivered" ? "#select_all" : selectAllId;
    if (
        $(checkboxClass + ":checked").length ==
        $(checkboxClass).length
    ) {
        $(actualSelectAllId).prop("checked", true);
    } else {
        $(actualSelectAllId).prop("checked", false);
    }
}

function trackerActionValidation() {
    var actions = $("#tracker_actions");
    var checkBoxRows = $(".not_delivered_checkbox");
    var trackerIdArry = [];

    if (!actions.val()) {
        var message = "No action is selected";
        showNotification(message, message, "gritter-red");
        actions.focus();
        return false;
    }

    checkBoxRows.each((index, checkboxElement) => {
        const isChecked = $(checkboxElement).is(":checked");

        if (isChecked) {
            trackerIdArry.push($(checkboxElement).val());
        }
    });

    if (actions.val() && trackerIdArry.length <= 0) {
        var message = "No tracker is checked";
        showNotification(message, message, "gritter-red");
        return false;
    }

    return {
        actions: actions.val(),
        trackers: trackerIdArry,
    };
}

function trackerActionException(URL) {
    var actions = $("#tracker_actions_exception");
    var checkBoxRows = $(".exception_checkbox");
    var trackerIdArry = [];

    if (!actions.val()) {
        var message = "No action is selected";
        showNotification(message, message, "gritter-red");
        actions.focus();
        return false;
    }

    checkBoxRows.each((index, checkboxElement) => {
        const isChecked = $(checkboxElement).is(":checked");

        if (isChecked) {
            trackerIdArry.push($(checkboxElement).val());
        }
    });

    if (actions.val() && trackerIdArry.length <= 0) {
        var message = "No tracker is checked";
        showNotification(message, message, "gritter-red");
        return false;
    }

    if (actions.val() === "bulk_check_for_update") {
        $.ajax({
            url: URL,
            method: "get",
            dataType: "json",
            data: {
                actions: actions.val(),
                trackers: trackerIdArry,
            },
        });
    }
}

function trackerActionDelayed(URL) {
    var actions = $("#tracker_actions_delayed");
    var checkBoxRows = $(".delayed_checkbox");
    var trackerIdArry = [];

    if (!actions.val()) {
        var message = "No action is selected";
        showNotification(message, message, "gritter-red");
        actions.focus();
        return false;
    }

    checkBoxRows.each((index, checkboxElement) => {
        const isChecked = $(checkboxElement).is(":checked");
        if (isChecked) {
            trackerIdArry.push($(checkboxElement).val());
        }
    });

    if (actions.val() && trackerIdArry.length <= 0) {
        var message = "No tracker is checked";
        showNotification(message, message, "gritter-red");
        return false;
    }

    if (actions.val() === "bulk_check_for_update") {
        $.ajax({
            url: URL,
            method: "get",
            dataType: "json",
            data: {
                actions: actions.val(),
                trackers: trackerIdArry,
            },
        });
    }
}

function trackerActionDelivered(URL) {
    var actions = $("#tracker_actions_delivered");
    var checkBoxRows = $(".delivered_checkbox");
    var trackerIdArry = [];

    if (!actions.val()) {
        var message = "No action is selected";
        showNotification(message, message, "gritter-red");
        actions.focus();
        return false;
    }

    checkBoxRows.each((index, checkboxElement) => {
        const isChecked = $(checkboxElement).is(":checked");

        if (isChecked) {
            trackerIdArry.push($(checkboxElement).val());
        }
    });

    if (actions.val() && trackerIdArry.length <= 0) {
        var message = "No tracker is checked";
        showNotification(message, message, "gritter-red");
        return false;
    }

    if (actions.val() === "bulk_check_for_update") {
        $.ajax({
            url: URL,
            method: "get",
            dataType: "json",
            data: {
                actions: actions.val(),
                trackers: trackerIdArry,
            },
        });
    }
}

function trackerActionDismissed(URL) {
    var actions = $("#tracker_actions_dismissed");
    var checkBoxRows = $(".dismissed_checkbox");
    var trackerIdArry = [];

    if (!actions.val()) {
        var message = "No action is selected";
        showNotification(message, message, "gritter-red");
        actions.focus();
        return false;
    }

    checkBoxRows.each((index, checkboxElement) => {
        const isChecked = $(checkboxElement).is(":checked");

        if (isChecked) {
            trackerIdArry.push($(checkboxElement).val());
        }
    });

    if (actions.val() && trackerIdArry.length <= 0) {
        var message = "No tracker is checked";
        showNotification(message, message, "gritter-red");
        return false;
    }

    if (actions.val() === "bulk_check_for_update") {
        $.ajax({
            url: URL,
            method: "get",
            dataType: "json",
            data: {
                actions: actions.val(),
                trackers: trackerIdArry,
            },
        });
    }
}

function bulkBarcodePrint(URL) {
    var actions = $("#tracker_actions_void");
    var checkBoxRows = $(".void_checkbox");
    var trackerIdArry = [];

    if (!actions.val()) {
        var message = "No action is selected";
        showNotification(message, message, "gritter-red");
        actions.focus();
        return false;
    }

    checkBoxRows.each((index, checkboxElement) => {
        const isChecked = $(checkboxElement).is(":checked");

        if (isChecked) {
            trackerIdArry.push($(checkboxElement).val());
        }
    });

    if (actions.val() && trackerIdArry.length <= 0) {
        var message = "No tracker is checked";
        showNotification(message, message, "gritter-red");
        return false;
    }

    if (actions.val() === "bulk_check_for_update") {
        $.ajax({
            url: URL,
            method: "get",
            dataType: "json",
            data: {
                actions: actions.val(),
                trackers: trackerIdArry,
            },
        });
    }
}

function showDeleteModal(trackerId) {
    Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Yes, delete it!"
    }).then((result) => {
        if (result.isConfirmed) {
            window.location.href = `/tracker/${trackerId}/delete`;
        }
    });
}

function confirmVoidAction(id, action) {
    Swal.fire({
        title: `Are you sure?`,
        text: `You are about to ${action.toLowerCase()} this tracker.`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: `Yes, ${action} it!`
    }).then((result) => {
        if (result.isConfirmed) {
            window.location.href = `/tracker/${id}/toggle-void`;
        }
    });
}

function trackerAction(URL) {
    var validData = trackerActionValidation();
    if (validData && validData.actions === "bulk_check_for_update") {
        $.ajax({
            url: URL,
            method: "get",
            dataType: "json",
            data: validData,
        });
    }
}

let trackerIdToDelete = null;
function confirmDelete(id) {
    trackerIdToDelete = id;
    const deleteModal = new bootstrap.Modal(document.getElementById('deleteConfirmModal'));
    deleteModal.show();
}
function executeDelete() {
    if (trackerIdToDelete) {
        window.location.href = `/tracker/${trackerIdToDelete}/delete`;
        trackerIdToDelete = null;
        const deleteModal = bootstrap.Modal.getInstance(document.getElementById('deleteConfirmModal'));
        if (deleteModal) {
            deleteModal.hide();
        }
    }
}

// expose globally
window.notDeliveredList      = notDeliveredList;
window.exceptionList         = exceptionList;
window.delayedList           = delayedList;
window.deliveredList         = deliveredList;
window.dismissedList         = dismissedList;
window.voidList              = voidList;
window.shippedTodayList      = shippedTodayList;

window.selectTabCheckbox     = selectTabCheckbox;
window.trackerActionValidation = trackerActionValidation;
window.trackerActionException  = trackerActionException;
window.trackerActionDelayed    = trackerActionDelayed;
window.trackerActionDelivered  = trackerActionDelivered;
window.trackerActionDismissed  = trackerActionDismissed;
window.bulkBarcodePrint        = bulkBarcodePrint;
window.showDeleteModal         = showDeleteModal;
window.confirmVoidAction       = confirmVoidAction;
window.trackerAction           = trackerAction;
window.confirmDelete           = confirmDelete;
window.executeDelete           = executeDelete;
